<template>
  <default-box>
    <div class="d-flex align-items-center justify-content-between cursor_pointer"
         @click.stop="statusToggle()">
      <div
          class="d-flex justify-content-between align-items-center col-12">
        <info-block
            class="fw-600 w-75"
            :success="has_report && report_loaded"
            :error="has_today_report_expired && !has_report && report_loaded">
          <template v-if="!report_loaded">
            {{ $t('dashboard.report_is_loading') }} {{ today }}
          </template>
          <template v-else>
            {{has_report ? $t('dashboard.you_filled_your_status') + ' ' + today : $t('dashboard.awaiting_for_your_status_report') + ' ' + today}}
          </template>
        </info-block>
        <default-button button_smaller>
          <chevron-down-icon :rotate="toggle.status"/>
        </default-button>
      </div>
    </div>
    <slide-up-down
      :tag="'div'"
      :active="toggle.status">
      <hr/>
      <user-daily-status-form class="min-width-0" @reportLoaded="report_loaded = true"/>
    </slide-up-down>
  </default-box>
</template>

<script>

import dateMixin from "../../../../mixins/dateMixin";
import {mapActions, mapGetters} from "vuex";
import {axiosUser} from "../../../../helpers/axios_requests";
import {MAX_HOUR} from "../../../../helpers/constants";
import DefaultBox from "../../../slots/DefaultBox.vue";
import InfoBlock from "../../../small_components/InfoBlock.vue";
import DefaultButton from "../../../small_components/DefaultButton.vue";
import ChevronDownIcon from "../../../icons/ChevronDownIcon.vue";
import SlideUpDown from "../../../small_components/SlideUpDown.vue";
import UserDailyStatusForm from "./UserDailyStatusForm.vue";

export default {
  name: "UserDailyStatus",
  components: {
    UserDailyStatusForm,
    SlideUpDown,
    ChevronDownIcon,
    DefaultButton,
    InfoBlock,
    DefaultBox
  },
  mixins: [dateMixin],
  computed: {
    ...mapGetters([
      'getUserHasDailyReport',
    ]),
    has_today_report_expired() {
      let date = this.getDateObj(new Date)
      return  MAX_HOUR < `${date.hours}:${date.minutes}`
    },
  },
  mounted() {
    const thisInstance = this;
    this.$root.$on('SetUserDailyStatus', function(){
      thisInstance.showDailyStatusForm();
      thisInstance.has_report = true;
    })
  },
  created() {
    this.showDailyStatusForm();
  },
  data() {
    return {
      toggle: {
        status: false
      },
      today: this.getDateFormatStrToShow(new Date(), '.'),
      has_report: true,
      report_loaded: false,
    }
  },
  methods: {
    ...mapActions([
      'actionSetUserDailyStatus'
    ]),
    showDailyStatusForm() {
      this.loading = true
      axiosUser.fetchHasTodayReport()
          .then(({data}) => {
            this.toggle.status = Boolean(!data.has_report)
            this.has_report = Boolean(data.has_report)
          })
          .finally(() => {
            this.loading = false
          })
    },
    statusToggle() {
      return this.toggle.status = !this.toggle.status
    }
  },
  watch: {
    has_report() {

    }
  }
}
</script>
